(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'AlertService', 'CartFactory', 'Principal', '$sessionStorage', 'LoginService', 'RegistrationService', '$state', '$stateParams', 'ProjectService', '$localStorage', '$translate', '$log', 'NO_PROJECT_URL', '$window', 'Auth', '$rootScope', '$sce', 'JhiLanguageService', '$uibModal', '$q'];

    function HomeController($scope, AlertService, CartFactory, Principal, $sessionStorage, LoginService, RegistrationService, $state, $stateParams, ProjectService, $localStorage, $translate, $log, NO_PROJECT_URL, $window, Auth, $rootScope, $sce, JhiLanguageService, $uibModal, $q) {
        // VARIABLES
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = false;
        vm.project = $stateParams.project;
        vm.welcomeHeadline = '';
        vm.welcomeText = '';
        vm.welcomeImage = '';
        vm.pendingLabel = '';
        vm.escInactiveLabel = '';
        vm.lang = $translate.use();
        vm.coExhibitors = [];

        // FUNCITONS PUBLIC
        vm.login = LoginService.open;
        vm.showLogin = showLoginButton;
        vm.isLoggedIn = isLoggedIn;
        vm.go = go;
        vm.newCoExhibitor = newCoExhibitor;
        vm.removeCoExhibitor = removeCoExhibitor;
        vm.editCoexhibitor = editCoexhibitor;


        $scope.$on('authenticationSuccess', function () {
            var authenticationToken = $localStorage.authenticationToken;
            var project = $localStorage.project;
            var projectinfo = $localStorage.projectinfo;
            var languages = $localStorage.languages;
            $localStorage.$reset();
            $sessionStorage.$reset();
            CartFactory.clear();
            $localStorage.authenticationToken = authenticationToken;
            $localStorage.project = project;
            $localStorage.projectinfo = projectinfo;
            $localStorage.languages = languages;
            $localStorage.exhibitorDataSet = false;
            getAccount();
            loadExhibitorInfo();
            loadCoExhibitors();
            vm.showLoginButton = false;
        });

        if (vm.project !== undefined) {
            $localStorage.$reset();
            $sessionStorage.$reset();
            Auth.logout();
            validateProject();
        } else {
            setProjectInfo();
        }

        if ($localStorage.showCoExhibitorLogoFeeAddedToCart !== undefined && $localStorage.showCoExhibitorLogoFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.coExhibitorLogoFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showCoExhibitorLogoFeeAddedToCart;
        }
        if ($localStorage.showLogoFeeAddedToCart !== undefined && $localStorage.showLogoFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.logoFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showLogoFeeAddedToCart;
        }
        if ($localStorage.showCoExhibitorFeeAddedToCart !== undefined && $localStorage.showCoExhibitorFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.coExhibitorFeeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showCoExhibitorFeeAddedToCart;
        }
        if ($localStorage.showFeeAddedToCart !== undefined && $localStorage.showFeeAddedToCart == true) {
            var successMsg = $translate.instant('home.feeAddedToCart');
            AlertService.success(successMsg, {}, 'bottom right');
            delete $localStorage.showFeeAddedToCart;
        }
        if (Principal.isAuthenticated()) {
            loadCoExhibitors();
            getAccount();
            loadExhibitorInfo();
        }

        // FUNCTION DECLARATIONS
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (vm.account && !$localStorage.exhibitorDataSet) {
                    Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
                        if (hasAuthority) {
                            register();
                        }
                    }, error);
                }
            }, function (error) {
                vm.isAuthenticated = false;
                // Ignore unhandled error
                return $q.reject(error);
            });
        }

        function book() {
            $state.go('area');
        }

        function register() {
            $state.go('registration');
        }

        function editCoexhibitor(id) {
            $log.debug('HomeController | edit co exhibitor:' + id);
            $state.go('registration', {"id": id});
        }

        function removeCoExhibitor(id) {
            var modal = $uibModal.open({
                templateUrl: 'app/components/confirm/confirm-dialog.html',
                controller: 'ModalConfirmController',
                size: 'md',
                windowClass: 'confirm-window',
                resolve: {
                    confirmTitle: function () {
                        return $translate.instant('home.coexhibitorremovetitle');
                    },
                    confirmMessage: function () {
                        return $translate.instant('home.coexhibitorremovedescription');
                    },
                    confirmCaption: function () {
                        return $translate.instant('entity.action.delete');
                    },
                    buttonClass: function () {
                        return 'btn-danger';
                    },
                    iconClass: function () {
                        return 'fa-trash-o';
                    },
                    cancelCaption: function () {
                        return $translate.instant('entity.action.cancel');
                    },
                    cancelButtonClass: function () {
                        return 'btn-default';
                    },
                    cancelIconClass: function () {
                        return 'fa-ban';
                    }
                }
            });

            modal.result.then(function () {
                $log.debug('HomeController | remove co exhibitor:' + id);
                if (id > 0) {
                    RegistrationService.deleteCoExhibitor(id).then(successCoExhibitorDeleted, error);
                } else {
                    var remove = false;
                    var index = 0;

                    angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                        if (exhibitor.id == id) {
                            remove = true;
                        }

                        if (!remove) {
                            index++;
                        }
                    });

                    if (remove) {
                        $localStorage.coExhibitors.splice(index, 1);
                        loadCoExhibitors();
                    }
                }
                CartFactory.removeCoExhibitorBookings(id);
            }, null);
        }

        function newCoExhibitor() {
            $log.debug('HomeController | new co exhibitor');
            // RegistrationService.createCoExhibitor().then(coExhibitorCreated, error);
            if ($localStorage.coExhibitors) {
                var newId = -1;
                angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                    if (Number(exhibitor.id) < newId) {
                        newId = Number(exhibitor.id);
                    }
                });
                $state.go('registration', {"id": newId - 1});
            } else {
                $localStorage.coExhibitors = [];
                $state.go('registration', {"id": -1});
            }
        }

        function go(where) {
            $state.go(where);
        }

        function loadCoExhibitors() {
            RegistrationService.loadCoExhibitors().then(successCoExhibitors, error);
        }

        function successCoExhibitorDeleted(response, id) {
            $log.debug('HomeController | co exhibitor deleted: ', response.data);
            $log.debug('HomeController | co exhibitor deleted id: ', id);
            if (response.data) {
                loadCoExhibitors();
            } else {
                var successMsg = $translate.instant('home.unabletodeletecoexhibitor');
                AlertService.error(successMsg, {}, 'bottom right');
            }
        }

        function coExhibitorCreated(response) {
            $log.debug('HomeController | co exhibitor created: ', response.data);
            $state.go('registration', {"id": response.data});
        }

        function loadExhibitorInfo() {
            Principal.hasAuthority('AUTHORIZATION_PENDING').then(function (value) {
                if (value) {
                    ProjectService.loadPendingLabels().then(successPendingLabels, error);
                }
            }, function () {
                $log.debug('HomeController | not logged in');
            });

            Principal.hasAuthority('ESC_INACTIVE').then(function (value) {
                if (value) {
                    ProjectService.loadEscInactiveLabels().then(successEscInactiveLabels, error);
                }
            }, function () {
                $log.debug('HomeController | not logged in');
            });
        }

        function successPendingLabels(response) {
            $log.debug('HomeController | fetching pending label: ', response.data);
            vm.pendingLabel = response.data;
        }

        function successEscInactiveLabels(response) {
            $log.debug('HomeController | fetching pending label: ', response.data);
            vm.escInactiveLabel = response.data;
        }

        function successCoExhibitors(response) {
            $log.debug('HomeController | fetching coExhibitors: ', response.data);
            vm.coExhibitors = response.data;
            if ($localStorage.coExhibitors) {
                angular.forEach($localStorage.coExhibitors, function (ex) {
                    vm.coExhibitors.push(ex);
                });
            }
        }

        function showLoginButton() {
            return !vm.isAuthenticated;
        }

        function isLoggedIn() {
            return !!vm.isAuthenticated;
        }

        function validateProject() {
            $log.debug('HomeController | validating project with name: ' + vm.project);
            ProjectService.validateProject(vm.project).then(storeProjectInLocalStorage, errorProject);
        }

        function isInteger(value) {
            return typeof value === "number" &&
                isFinite(value) &&
                Math.floor(value) === value;
        }

        function storeProjectInLocalStorage(response) {
            $log.debug('HomeController | Project-Id received: ', response.data);
            if (isInteger(response.data) && response.data > 0) {
                var project = response.data;
                $localStorage.project = project;
                loadProjectInfo(project);
            } else {
                $log.debug('HomeController | ERROR getting project-id, go to', NO_PROJECT_URL);
                $window.location.assign(NO_PROJECT_URL);
            }
        }

        function loadProjectInfo(project) {
            return ProjectService.loadProjectInfo(project)
                .then(function (response) {
                    $log.debug('HomeController | Project info fetching successful', response.data);
                    $localStorage.projectinfo = response.data;
                    setProjectInfo();
                }, function (data) {
                    $log.debug('HomeController | error fetching project info', data);
                });
        }

        function setProjectInfo() {
            $log.debug('HomeController | Project-Info: ', $localStorage.projectinfo);
            if ($localStorage.projectinfo !== undefined) {
                vm.welcomeHeadline = $localStorage.projectinfo.title[vm.lang];
                vm.welcomeText = $sce.trustAsHtml($localStorage.projectinfo.description[vm.lang]);
                vm.welcomeImage = $localStorage.projectinfo.image;
                JhiLanguageService.setLanguages($localStorage.projectinfo.languages);
            } else {
                $window.location.assign(NO_PROJECT_URL);
            }
        }

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            setProjectInfo();
        });

        function error(response) {
            $log.debug('HomeController | ERROR', response);
        }

        function errorProject(response) {
            $log.debug('HomeController | ERROR', response);
            $window.location.assign(NO_PROJECT_URL);
        }

    }
})();
